import $ from 'jquery';
import lazy from 'jquery-lazy';
import Navigo from 'navigo';
import WOW from 'wowjs';
import slick from 'slick-carousel';

const root = null;
const useHash = true;
const router = new Navigo(root, useHash);
let currentIndex = 0;
const wow = new WOW.WOW();
let rightAnswers = 0;

// slider
const $slick_slider = $('.js-gifs-slider');
const settings_slider = {
	mobileFirst: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	dots: false,
	arrows: false,
	autoplay: true,
	autoplaySpeed: 2000
};


function setScreenIndex(i) {
	currentIndex = +i;
}

function getScreenIndex() {
	return currentIndex;
}

function smoothScrollToElem(elem, disabled = false) {
	if (!disabled) {
		$('.overlay').addClass('active');
	}
	const delay = disabled ? 500 : 0;
	$('html, body').animate({
		scrollTop: elem.offset().top
	}, delay);
	setTimeout(function (){
		$('.overlay').removeClass('active');
	}, 500);
}

function controlBtns(i) {
	if (i >= $('.screen').length) {
		$('.js-nextPage').hide();
		$('.js-mainPage').show();
	} else {
		$('.js-nextPage').show();
		$('.js-mainPage').hide();
	}

	if (i <= 1) {
		$('.js-prevPage').hide();
	} else {
		$('.js-prevPage').show();
	}
}

function showPageByIndex(i) {
	setScreenIndex(i);
	$('.screen').removeClass('is-show');
	$('.screen').eq(i - 1).addClass('is-show');
	const content = $('.screen').eq(i - 1);
	smoothScrollToElem(content);

	controlBtns(i);
}

function clickHandler(e, next = true) {
	e.preventDefault();
	const index = next ? getScreenIndex() + 1 : getScreenIndex() - 1;
	router.pause();
	router.navigate(`${index}`);
	router.resume();
}

function showResult() {
	const index = getScreenIndex() - 1;
	const elem = $('.result').eq(index);
	// Удаляем классы, чтобы нельзя было больше кликнуть на варианты
	$(this).parent().find('.losses__item').removeClass('js-losses-item');
	if ($(this).data('answer')) {
		$(elem).find('.js-result-text').removeClass('false').addClass('true').text('Верно!');
		rightAnswers += 1;
	} else {
		$(elem).find('.js-result-text').removeClass('true').addClass('false').text('Промахнулись! На самом деле...');
	}
	$(this).closest('.screen').addClass('active');
	smoothScrollToElem(elem, true);
	initCanvas(getScreenIndex());
}

function showAllResult() {
	const elem = $('.footer_final');
	const text = elem.find('.js-result-field');
	text.text(`Вы правильно ответили на ${rightAnswers} / 10`);
	elem.show();

	$('html, body').animate({
		scrollTop: elem.offset().top
	}, 500);
}

function goToMain(e) {
	e.preventDefault();
	router.navigate('1');
}

router.on({
	':id': (params) => {
		if (params.id > $('.screen').length) {
			router.navigate('1');
		} else {
			showPageByIndex(params.id);
		}
	},
	'*': () => {
		const elem = $('body');
		setScreenIndex(1);
		$('.screen1').addClass('is-show');
		controlBtns(1);
		smoothScrollToElem(elem);
	}
}).resolve();


function loadjsfile(filename){
	$('#animationScript').remove();
    var fileref=document.createElement('script')
    fileref.setAttribute("type","text/javascript")
    fileref.setAttribute("src", '/animation/'+filename+'.js');
	fileref.setAttribute("id", 'animationScript');
	$('script#createjs').after(fileref);
}

var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;

function initCanvas(id) {
	canvas = document.getElementById("canvas" + id);
	loadjsfile(id);
	anim_container = document.getElementById("animation" + id);
	dom_overlay_container = document.getElementById("overlay" + id);
	var comp=AdobeAn.getComposition("2EB5BC4040F91B49B299FAB88053CBA6");
	var lib=comp.getLibrary();

	handleComplete({},comp, id, lib);
}
function handleComplete(evt, comp, id) {
	//This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
	var lib=comp.getLibrary();
	var ss=comp.getSpriteSheet();
	exportRoot = new lib['_' + id]();
	stage = new lib.Stage(canvas);
	//Registers the "tick" event listener.
	fnStartAnimation = function() {
		stage.addChild(exportRoot);
		createjs.Ticker.setFPS(lib.properties.fps);
		createjs.Ticker.addEventListener("tick", stage);
	}
	//Code to support hidpi screens and responsive scaling.
	function makeResponsive(isResp, respDim, isScale, scaleType) {
		var lastW, lastH, lastS=1;
		window.addEventListener('resize', resizeCanvas);
		resizeCanvas();
		function resizeCanvas() {
			var w = lib.properties.width, h = lib.properties.height;
			var iw = window.innerWidth, ih=window.innerHeight;
			var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;
			if(isResp) {
				if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {
					sRatio = lastS;
				}
				else if(!isScale) {
					if(iw<w || ih<h)
						sRatio = Math.min(xRatio, yRatio);
				}
				else if(scaleType==1) {
					sRatio = Math.min(xRatio, yRatio);
				}
				else if(scaleType==2) {
					sRatio = Math.max(xRatio, yRatio);
				}
			}
			canvas.width = w*pRatio*sRatio;
			canvas.height = h*pRatio*sRatio;
			canvas.style.width = dom_overlay_container.style.width = anim_container.style.width =  '100%';
			canvas.style.height = anim_container.style.height = dom_overlay_container.style.height = 'auto';
			stage.scaleX = pRatio*sRatio;
			stage.scaleY = pRatio*sRatio;
			lastW = iw; lastH = ih; lastS = sRatio;
			stage.tickOnUpdate = false;
			stage.update();
			stage.tickOnUpdate = true;
		}
	}
	makeResponsive(true,'both',true,1);
	AdobeAn.compositionLoaded(lib.properties.id);
	fnStartAnimation();
}

$(() => {
	wow.init();

	$('.js-nextPage').on('click', e => clickHandler(e));
	$('.js-prevPage').on('click', e => clickHandler(e, false));
	$('.js-mainPage').on('click', e => goToMain(e));

	$(document).on('click', '.js-losses-item', showResult);

	$('.js-showResult').on('click', function(e) {
		e.preventDefault();

		showAllResult();
	});


	slick_on_mobile( $slick_slider, settings_slider);

	// slick on mobile
	function slick_on_mobile(slider, settings) {
		$(window).on('load resize', function () {
			if ($(window).width() > 767) {
				if (slider.hasClass('slick-initialized')) {
					slider.slick('unslick');
				}
				return;
			}
			if (!slider.hasClass('slick-initialized')) {
				return slider.slick(settings);
			}
		});
	};

	$('.lazy').lazy({
		visibleOnly: true,
		effect: 'fadeIn',
		effectTime: 500
	});
});



// WEBPACK FOOTER //
// ./app/scripts/app.js